// extracted by mini-css-extract-plugin
module.exports = {"switch":"SwitchButton_switch__2f6i-","slider":"SwitchButton_slider__1U-6z","round":"SwitchButton_round__1LpGb"};